import { apiClient } from './client'
import type {
  ChangePasswordRequest,
  DeleteAccountRequest,
  UpdateSettingsRequest,
  UserSettings,
} from '@/types/settings'

export const settingsApi = {
  getSettings: () => apiClient.get<UserSettings>('/settings').then((r) => r.data),

  updateSettings: (data: UpdateSettingsRequest) =>
    apiClient.put<UserSettings>('/settings', data).then((r) => r.data),

  changePassword: (data: ChangePasswordRequest) =>
    apiClient.put<void>('/settings/password', data),

  deleteAccount: (data: DeleteAccountRequest) =>
    apiClient.delete<void>('/settings/account', { data }),
}
